import React, {Component} from "react";
import {graphql} from "react-apollo";
import {fromJS, List} from "immutable";
import Table from "../../../components/Table";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import PaginatorButton from "../../../components/PaginatorButton";
import ClientDispatchItem from "./ClientDispatchItem";
import {LIST_CLIENT_DISPATCHES, ON_CLIENT_DISPATCH_UPDATED} from "../../../queries/clientDispatches";

const tableHeader = List(["Dispatch #", "Client", "Client Reference", "From", "Date", "Qty", "Status"]);

class ClientDispatchesList extends Component {

  componentDidMount() {
    const {data} = this.props;
    this.unsubscribe = data.subscribeToMore({
      document: ON_CLIENT_DISPATCH_UPDATED,
      updateQuery: (prev) => {
        data.refetch();
        return prev;
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    const {loading, error, clientDispatches} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    const dispatches = fromJS(clientDispatches);
    return (
      <div>
        <Table
          data={dispatches.get("entries")}
          renderer={ClientDispatchItem}
          onItemClick={(itemData) => this.props.onSelectionChange(itemData.get("id"))}
          tableHeader={tableHeader}
          extraClassName="ClientDispatchesList"
          itemKey="id"
          mode="table"
          showCount={true}
          />
        <PaginatorButton metadata={dispatches.get("metadata")} onNext={this.handleNext.bind(this)} />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {pagination: {after: afterId}},
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          clientDispatches: {
            __typename: prev.clientDispatches.__typename,
            metadata: fetchMoreResult.clientDispatches.metadata,
            entries: [...prev.clientDispatches.entries, ...fetchMoreResult.clientDispatches.entries]
          }
        }
      }
    })
  }
}

export default graphql(LIST_CLIENT_DISPATCHES, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        status: props.statusFilter,
        partnerId: props.partnerFilter,
        originWarehouseId: props.originFilter,
      }
    }
  })
})(ClientDispatchesList);
